"use client";

import { useState } from "react";

import { LeadCaptureModal } from "@/components/lead-capture-modal";

// Small client wrapper so the /about CTA opens the same
// LeadCaptureModal the header and footer use site-wide. Styled by
// the `.cta-btn` rule in about/page.tsx's scoped CSS (solid green
// pill) — no rainbow border, no bespoke styling here.
export function BookDemoCta() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className="cta-btn"
        onClick={() => setOpen(true)}
      >
        Book a Demo
      </button>
      <LeadCaptureModal open={open} onOpenChange={setOpen} />
    </>
  );
}
